import Request from "../../../services/request";

const defaultEntry = () => ({
  id: null,
  name: null,
  code: null,
  description: null,
  seo_title: null,
  seo_description: null,
  seo_keywords: null,
  ids_specifications: [],
  id_company: null,
  id_city: null,
  id_module_scheme: null,
  _company: null,
  _city: null,
  _module_scheme: null,
});

export default {
  namespaced: true,
  state: {
    listEntries: [],
    entry: defaultEntry(),
    listSpecs: [],
    listTemplateNomenclaturesSpec: [],
    listNomenclatures: [],
    listCities: [],
    listModuleSchemes: [],
  },
  mutations: {
    changeListEntries(state, array) {
      state.listEntries = Array.isArray(array) ? array : Object.values(array);
    },
    setEntry(state, data) {
      if (!data) return;
      state.entry = { ...defaultEntry(), ...data };
    },
    setEntryData(state, data) {
      state.entry = { ...state.entry, ...data };
    },
    clearEntry(state) {
      state.entry = defaultEntry();
      state.listSpecs = [];
      state.listTemplateNomenclaturesSpec = [];
    },
    setListSpecs(state, specs) {
      state.listSpecs = specs;
    },
    updateSpec(state, spec) {
      const idx = state.listSpecs.findIndex((s) => s.id === spec.id);
      if (idx !== -1) state.listSpecs.splice(idx, 1, spec);
      else state.listSpecs.push(spec);
    },
    removeSpecFromList(state, specId) {
      state.listSpecs = state.listSpecs.filter((s) => s.id !== specId);
    },
    change_list_nomenclature(state, data) {
      state.listNomenclatures = data;
    },
    change_list_cities(state, data) {
      state.listCities = data;
    },
    change_list_module_schemes(state, data) {
      state.listModuleSchemes = data;
    },
    setTemplateNomenclaturesSpec(state, data) {
      state.listTemplateNomenclaturesSpec = data;
    },
    addTemplateNomenclatureSpec(state, item) {
      state.listTemplateNomenclaturesSpec.push(item);
    },
    updateTemplateNomenclatureSpecItem(state, item) {
      const idx = state.listTemplateNomenclaturesSpec.findIndex((r) => r.id === item.id);
      if (idx !== -1) state.listTemplateNomenclaturesSpec.splice(idx, 1, item);
    },
    removeTemplateNomenclatureSpec(state, id) {
      state.listTemplateNomenclaturesSpec = state.listTemplateNomenclaturesSpec.filter(
        (r) => r.id !== id
      );
    },
  },
  actions: {
    clearEntry({ commit }) {
      commit("clearEntry");
    },

    async getListEntries({ commit }) {
      commit("changeLoadingGeneral", true, { root: true });
      try {
        const query = Request.modifyQuery([], ["*"]);
        const result = await Request.get(
          this.state.BASE_URL + `/entity/primery-rabot${query}`
        );
        commit("changeListEntries", result.data);
      } catch (e) {
        commit("change_notification_modal", e, { root: true });
      }
      commit("changeLoadingGeneral", false, { root: true });
    },

    async createEntry({ commit, state }) {
      commit("changeLoadingGeneral", true, { root: true });
      try {
        const response = await Request.post(
          this.state.BASE_URL + "/entity/primery-rabot",
          state.entry
        );
        commit("setEntry", response.data);
        commit("changeLoadingGeneral", false, { root: true });
        return response;
      } catch (e) {
        commit("change_notification_modal", e, { root: true });
        commit("changeLoadingGeneral", false, { root: true });
      }
    },

    async updateEntry({ commit, state }) {
      commit("changeLoadingGeneral", true, { root: true });
      const response = await Request.put(
        this.state.BASE_URL + "/entity/primery-rabot/" + state.entry.id,
        state.entry
      );
      if (!response.isError) commit("setEntry", response.data);
      commit("changeLoadingGeneral", false, { root: true });
      return response;
    },

    async deleteEntry({ commit, state }) {
      commit("changeLoadingGeneral", true, { root: true });
      // Удаляем все дочерние спецификации
      const ids = state.entry.ids_specifications || [];
      for (const specId of ids) {
        const spec = state.listSpecs.find((s) => s.id === specId);
        if (spec?._image?.id) {
          await this.dispatch("deleteFileGeneral", spec._image.id, {
            root: true,
          });
        }
        await Request.delete(
          this.state.BASE_URL + "/entity/specifications/" + specId
        );
      }
      await Request.delete(
        this.state.BASE_URL + "/entity/primery-rabot/" + state.entry.id
      );
      commit("changeLoadingGeneral", false, { root: true });
    },

    async loadSpecifications({ commit, state }) {
      const ids = state.entry.ids_specifications;
      if (!ids || !ids.length) {
        commit("setListSpecs", []);
        return;
      }
      const query = Request.modifyQuery([], ["*", "_image", "_hotspots"]);
      const specs = await Promise.all(
        ids.map((id) =>
          Request.get(
            this.state.BASE_URL + `/entity/specifications/${id}${query}`
          )
        )
      );
      commit(
        "setListSpecs",
        specs.filter((r) => !r.isError).map((r) => r.data)
      );
    },

    async addSpecification({ commit, state, dispatch }, id_image) {
      commit("changeLoadingGeneral", true, { root: true });
      const specResp = await Request.post(
        this.state.BASE_URL + "/entity/specifications",
        { id_image, name: state.entry.name || "spec" }
      );
      if (specResp.isError) {
        commit("changeLoadingGeneral", false, { root: true });
        return null;
      }
      const newIds = [...(state.entry.ids_specifications || []), specResp.data.id];
      commit("setEntryData", { ids_specifications: newIds });
      await dispatch("updateEntry");
      await dispatch("refreshSpec", specResp.data.id);
      commit("changeLoadingGeneral", false, { root: true });
      return specResp.data.id;
    },

    async removeSpecification({ commit, state, dispatch }, specId) {
      commit("changeLoadingGeneral", true, { root: true });
      const newIds = (state.entry.ids_specifications || []).filter(
        (id) => id !== specId
      );
      commit("setEntryData", { ids_specifications: newIds });
      await dispatch("updateEntry");
      const spec = state.listSpecs.find((s) => s.id === specId);
      if (spec?._image?.id) {
        await this.dispatch("deleteFileGeneral", spec._image.id, { root: true });
      }
      await Request.delete(
        this.state.BASE_URL + "/entity/specifications/" + specId
      );
      commit("removeSpecFromList", specId);
      commit("changeLoadingGeneral", false, { root: true });
    },

    async refreshSpec({ commit, state }, specId) {
      const query = Request.modifyQuery([], ["*", "_image", "_hotspots"]);
      const response = await Request.get(
        this.state.BASE_URL + `/entity/specifications/${specId}${query}`
      );
      if (!response.isError) commit("updateSpec", response.data);
    },

    async getListNomenclature({ commit }) {
      const query = Request.modifyQuery([], ["*", "_name_category", "_name_family"]);
      const response = await Request.get(
        `${this.state.BASE_URL}/entity/nomenclature${query}`
      );
      commit("change_list_nomenclature", response.data);
    },

    async getListCities({ commit }) {
      const response = await Request.get(
        `${this.state.BASE_URL}/dictionary/cities?select[]=id&select[]=city`
      );
      commit("change_list_cities", response.data);
    },

    async getListModuleSchemes({ commit }) {
      const response = await Request.get(
        `${this.state.BASE_URL}/dictionary/module-schemes?select[]=id&select[]=name&select[]=code`
      );
      commit("change_list_module_schemes", response.isError ? [] : response.data);
    },

    async loadTemplateNomenclaturesSpec({ commit, state }) {
      if (!state.entry.id) return;
      const query = Request.modifyQuery(
        { id_primery_rabot: state.entry.id },
        ["*", "_tag"]
      );
      const response = await Request.get(
        `${this.state.BASE_URL}/entity/templates-nomenclatures-by-spec${query}`
      );
      commit("setTemplateNomenclaturesSpec", response.isError ? [] : response.data);
    },

    async createTemplateNomenclatureSpec({ commit, state }, payload) {
      const response = await Request.post(
        `${this.state.BASE_URL}/entity/templates-nomenclatures-by-spec`,
        { ...payload, id_primery_rabot: state.entry.id }
      );
      if (!response.isError) commit("addTemplateNomenclatureSpec", response.data);
      return response;
    },

    async updateTemplateNomenclatureSpec({ commit, state }, { id, payload }) {
      const response = await Request.put(
        `${this.state.BASE_URL}/entity/templates-nomenclatures-by-spec/${id}`,
        { ...payload, id_primery_rabot: state.entry.id }
      );
      if (!response.isError) commit("updateTemplateNomenclatureSpecItem", response.data);
      return response;
    },

    async deleteTemplateNomenclatureSpec({ commit }, id) {
      await Request.delete(
        `${this.state.BASE_URL}/entity/templates-nomenclatures-by-spec/${id}`
      );
      commit("removeTemplateNomenclatureSpec", id);
    },
  },
  getters: {},
};